import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "breadcrumb"
};
const _hoisted_2 = {
  class: "header-right"
};
const _hoisted_3 = {
  class: "header-user-con"
};
const _hoisted_4 = {
  class: "el-dropdown-link"
};
import { onMounted, ref, watch } from "vue";
import { getMenuItems, useSidebarStore } from "@/store/sidebar";
import { useRouter } from "vue-router";
import { ArrowDown, ArrowRight, Expand, Fold, Moon, Sunny } from "@element-plus/icons-vue";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import { removeAdminToken } from "@/store/session";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'AdminHeader',
  setup(__props) {
    const version = ref(process.env.VUE_APP_VERSION);
    const avatar = ref("/images/user-info.jpg");
    const sidebar = useSidebarStore();
    const router = useRouter();
    const breadcrumb = ref([]);
    const store = useSharedStore();
    const dark = ref(store.theme === "dark");
    const theme = ref(store.theme);
    watch(() => store.theme, val => {
      theme.value = val;
    });
    const changeTheme = () => {
      store.setTheme(dark.value ? "dark" : "light");
    };
    router.afterEach(to => {
      initBreadCrumb(to.path);
    });
    onMounted(() => {
      initBreadCrumb(router.currentRoute.value.path);
    });

    // 初始化面包屑导航
    const initBreadCrumb = path => {
      breadcrumb.value = [{
        title: "首页"
      }];
      const items = getMenuItems();
      if (items) {
        let bk = false;
        for (let i = 0; i < items.length; i++) {
          if (items[i].index === path) {
            breadcrumb.value.push({
              title: items[i].title,
              path: items[i].index
            });
            break;
          }
          if (bk) {
            break;
          }
          if (items[i]["subs"]) {
            const subs = items[i]["subs"];
            for (let j = 0; j < subs.length; j++) {
              if (subs[j].index === path) {
                breadcrumb.value.push({
                  title: items[i].title,
                  path: items[i].index
                });
                breadcrumb.value.push({
                  title: subs[j].title,
                  path: subs[j].index
                });
                bk = true;
                break;
              }
            }
          }
        }
      }
    };

    // 侧边栏折叠
    const collapseChange = () => {
      sidebar.handleCollapse();
    };
    onMounted(() => {
      if (document.body.clientWidth < 1024) {
        collapseChange();
      }
    });
    const logout = function () {
      httpGet("/admin/logout").then(() => {
        removeAdminToken();
        router.replace("/admin/login");
      }).catch(e => {
        ElMessage.error("注销失败: " + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass('admin-header ' + theme.value)
      }, [_createElementVNode("div", {
        class: "collapse-btn",
        onClick: collapseChange
      }, [_unref(sidebar).collapse ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_unref(Expand))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_unref(Fold))]),
        _: 1
      }))]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        "separator-icon": _unref(ArrowRight)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumb.value, item => {
          return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["separator-icon"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_switch, {
        style: {
          "margin-right": "10px"
        },
        modelValue: dark.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dark.value = $event),
        "inline-prompt": "",
        "active-action-icon": _unref(Moon),
        "inactive-action-icon": _unref(Sunny),
        onChange: changeTheme
      }, null, 8, ["modelValue", "active-action-icon", "inactive-action-icon"]), _createVNode(_component_el_dropdown, {
        class: "user-name",
        "hide-on-click": true,
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("i", {
              class: "iconfont icon-version"
            }, null, -1)), _createTextVNode(" 当前版本：" + _toDisplayString(version.value), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: logout
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("i", {
              class: "iconfont icon-logout"
            }, null, -1), _createElementVNode("span", null, "退出登录", -1)])),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_avatar, {
          class: "user-avatar",
          size: 30,
          src: avatar.value
        }, null, 8, ["src"]), _createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })])]),
        _: 1
      })])])], 2);
    };
  }
};